// import FontIcon from "react-md/lib/FontIcons";
import Link from "gatsby-link";

function GetNavList(config) {
  const NavList = [
    {
      primaryText: "Home",
      // LeftIcon: <p>home</p>,
      component: Link,
      to: "/"
    },
    {
      primaryText: "About",
      // LeftIcon: <p>home</p>,
      component: Link,
      to: "/about"
    },
    {
      divider: true
    }
  ];

  if (config.menuLinks) {
    config.menuLinks.forEach(link => {
      NavList.push({
        primaryText: link.label,
        // LeftIcon: <FontIcon forceSize iconClassName={link.iconClassName} />,
        component: "a",
        href: link.url
      });
    });
  }

  NavList.push({ divider: true });
  return NavList;
}
export default GetNavList;



// WEBPACK FOOTER //
// ./src/components/Navigation/GetNavList.jsx